// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Vue from "vue";
import "@similar/bridge"; // similar
import router from "./router/index";
import App from "./App.vue";
import "normalize.css";
import VueI18n from "vue-i18n";
import { dynamicImportLocale } from "./utils";
import "@/utils/directive";

(window as any).similar = similar;

try {
  (window as any).similar.ui.setPulldown({
    type: 0, // Int: 1-允许下拉，0-不允许下拉
  });
} catch {
  console.log("bridge err");
}

Vue.config.productionTip = false;

Vue.use(VueI18n);

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n();
// {
//   locale: navigator.userAgent.match(/lan\/(\w+?) /)?.[1] || 'en', // 设置地区
//   messages: {
//     en: {
//       message: {
//         hello: 'hello world'
//       }
//     },
//     ja: {
//       message: {
//         hello: 'こんにちは、世界'
//       }
//     }
//   }, // 设置地区信息
// }

// 初始化 window._i18n_ 对象
(window as any)._i18n_ = {
  isArLanguage: false
};

// 先加载语言，再挂载 Vue 实例，确保 v-ar 指令能正确工作
dynamicImportLocale().then(({ language, message }) => {
  i18n.setLocaleMessage(language, message);
  i18n.locale = language;
  // 设置是否为阿拉伯语
  (window as any)._i18n_.isArLanguage = language === 'ar';
  // 设置 body 标签的 language 属性，用于触发阿拉伯语样式
  document.body.setAttribute('language', language);
  
  // 在语言加载完成后再挂载 Vue 实例
  new Vue({
    i18n,
    router,
    render: (h) => h(App),
  }).$mount("#app");
});
